import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/** A titled list of short facts. */
export const Bullets = memo(
  ({ title, items }: { title: string; items: string[] }) => {
    const { rpx } = useResponsiveContext();
    if (!items.length) return null;
    return (
      <View style={{ gap: rpx(6) }}>
        <Typography.Text size={rpx(12)} bold color={aiColors.foreground}>
          {title}
        </Typography.Text>
        {items.map((item, i) => (
          <View key={i} style={{ flexDirection: 'row', gap: rpx(8) }}>
            <View
              style={{
                width: rpx(4),
                height: rpx(4),
                borderRadius: rpx(2),
                marginTop: rpx(7),
                backgroundColor: aiColors.mutedForeground,
              }}
            />
            <Typography.Text
              size={rpx(12)}
              color={aiColors.mutedForeground}
              lineHeight={rpx(18)}
              style={{ flex: 1 }}
            >
              {item}
            </Typography.Text>
          </View>
        ))}
      </View>
    );
  },
);

/** What the coach filled in, marked so the trainee can correct it. */
export const AssumedItems = memo(({ items }: { items: string[] }) => {
  const { rpx } = useResponsiveContext();
  if (!items.length) return null;
  return (
    <View style={{ gap: rpx(6) }}>
      {items.map((item, i) => (
        <View
          key={i}
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: rpx(8),
            borderRadius: rpx(8),
            borderWidth: 1,
            borderColor: tint(aiColors.amber, 0.4),
            backgroundColor: tint(aiColors.amber, 0.1),
            padding: rpx(10),
          }}
        >
          <View
            style={{
              borderRadius: rpx(4),
              paddingHorizontal: rpx(6),
              paddingVertical: rpx(1),
              backgroundColor: aiColors.amber,
            }}
          >
            <Typography.Text size={rpx(10)} bold color="#fff">
              假设
            </Typography.Text>
          </View>
          <Typography.Text
            size={rpx(12)}
            color={aiColors.foreground}
            lineHeight={rpx(18)}
            style={{ flex: 1 }}
          >
            {item}
          </Typography.Text>
        </View>
      ))}
    </View>
  );
});
